import ManagePage from './manage-page'
export default ManagePage
